import { render, staticRenderFns } from "./UserGoldList.vue?vue&type=template&id=bb767440&scoped=true"
import script from "./UserGoldList.vue?vue&type=script&lang=js"
export * from "./UserGoldList.vue?vue&type=script&lang=js"
import style0 from "./UserGoldList.vue?vue&type=style&index=0&id=bb767440&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb767440",
  null
  
)

export default component.exports